require('./Content.less');



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Content/Content.js
// module id = 138
// module chunks = 0